module.exports = __webpack_public_path__ + "img/r_book.07ebc18c.png";